
    import Vue from "vue";
    import { Prop, Watch, Component } from "vue-property-decorator";
    import { mask } from 'vue-the-mask';
    import * as Pagos from '@lib/Ventas/Pagos'
    @Component( {
        name: "Componente",
        directives: { mask },
        props: {},
        components: {}
    } )
    export default class Componente extends Vue {

        @Prop( { type: Boolean } ) public disabled: boolean;
        @Prop( { type: Boolean } ) public readonly: boolean;

        @Prop( { type: Pagos.Plataformas } )
        public value: Pagos.Plataformas;

        @Watch( 'value', { immediate: true } )
        onIndex() {
            this.Selected = this.value;
        }

        constructor() {
            super();
        }

        public items: Array<Pagos.Plataformas> = Pagos.Plataformas.Bancarios;

        public selected: Pagos.Plataformas | null = null;
        public get Selected(): Pagos.Plataformas | null {
            return this.selected;
        }
        public set Selected( x: Pagos.Plataformas | null ) {
            this.selected = x;
            this.$emit( 'input', this.Selected );
        }

        public async onLostFocus( event: any ) {

        }
    }
